import { render, staticRenderFns } from "./BitcoinList.vue?vue&type=template&id=4ff83754&scoped=true"
import script from "./BitcoinList.vue?vue&type=script&lang=js"
export * from "./BitcoinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff83754",
  null
  
)

export default component.exports